<template>
  <v-container fluid>
    <div class="marco">
      <v-row no-gutters>
        <v-col cols="12">
          <span class="titulos">
            Certificación de origen T-MEC / USMCA / CUSMA
          </span>
        </v-col>
        <v-col cols="12">
          <div class="container" style="display:flex;">
            <div class="textos">
              Certificador:
            </div>
            <div style="width:30px;"></div>
            <div
              class="textos"
              style="display:flex;"
              v-if="infoDespues.TIPOUSUARIOTMEC == 'PRODUCTOR'"
            >
              <input type="radio" />
              <div style="width:10px;"></div>
              Importador
              <div style="width:30px;"></div>
              <input type="radio" />
              <div style="width:10px;"></div>Exportador
              <div style="width:30px;"></div>
              <input type="radio" checked />
              <div style="width:10px;"></div>Productor
            </div>
            <div
              class="textos"
              style="display:flex;"
              v-if="infoDespues.TIPOUSUARIOTMEC == 'EXPORTADOR'"
            >
              <input type="radio" />
              <div style="width:10px;"></div>Importador
              <div style="width:30px;"></div>
              <input type="radio" checked />
              <div style="width:10px;"></div>Exportador
              <div style="width:30px;"></div>
              <input type="radio" />
              <div style="width:10px;"></div>Productor
            </div>
            <div
              class="textos"
              style="display:flex;"
              v-if="infoDespues.TIPOUSUARIOTMEC == 'IMPORTADOR'"
            >
              <input type="radio" checked />
              <div style="width:10px;"></div>Importador
              <div style="width:30px;"></div>
              <input type="radio" />
              <div style="width:10px;"></div>Exportador
              <div style="width:30px;"></div>
              <input type="radio" />
              <div style="width:10px;"></div>Productor
            </div>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="titulos">
            DETALLES DEL CERTIFICADOR
          </div>
          <!-- DETALLES DEL CERTIFICADOR -->
          <div class="textos">
            <div>NOMBRE:</div>
            <div style="background-color:#D5DBDB;">
              {{ detallesCertificadorNombre }}
            </div>
            <div>DOMICILIO:</div>
            <div style="background-color:#D5DBDB;">
              {{ detallesCertificadorDomicilio }}
            </div>
            <div style="display:flex;">
              <div style="width:50%;">
                <div>TELÉFONO:</div>
                <div style="background-color:#D5DBDB;">
                  {{ detallesCertificadorTelefono }}
                </div>
              </div>
              <div style="width:50%;">
                <div>CORREO ELECTRÓNICO:</div>
                <div style="background-color:#D5DBDB;">
                  {{ detallesCertificadorCorreoElectronico }}
                </div>
              </div>
            </div>
            <div>REGISTRO FEDERAL DE CONTRIBUYENTES:</div>
            <div style="background-color:#D5DBDB;">{{ rfcCertificador }}</div>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="titulos">
            DETALLES DEL EXPORTADOR
          </div>
          <div class="textos">
            <div>NOMBRE:</div>
            <div style="background-color:#D5DBDB;">{{ detallesExportadorNombre }}</div>
            <div>DOMICILIO:</div>
            <div style="background-color:#D5DBDB;">{{ detallesExportadorDomicilio }}</div>
            <div>TELÉFONO:</div>
            <div style="background-color:#D5DBDB;">{{ detallesExportadorTelefono }}</div>
            <div>REGISTRO FEDERAL DE CONTRIBUYENTES:</div>
            <div style="background-color:#D5DBDB;">{{ rfcExportador }}</div>
          </div></v-col
        >
      </v-row>
      <v-row no-gutters>
        <v-col cols="6">
          <div class="titulos">
            DETALLES DEL PRODUCTOR
          </div>
          <div style="font-size:10px;display:inline-flex;">
            <div class="mr-2" v-if="infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES">
              <input type="checkbox" checked /> Varios productores
            </div>
            <div class="mr-2" v-if="!infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES">
              <input type="checkbox" /> Varios productores
            </div>
            <!-- separador -->
            <div v-if="infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS">
              <input type="checkbox" checked /> Disponible a solicitud de las autoridades
              importadoras
            </div>
            <div v-if="!infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS">
              <input type="checkbox" /> Disponible a solicitud de las autoridades importadoras
            </div>
          </div>
          <div class="textos">
            <div>NOMBRE:</div>
            <div style="background-color:#D5DBDB;">{{ detallesProductorNombre }}</div>
            <div>DOMICILIO:</div>
            <div style="background-color:#D5DBDB;">{{ detallesProductorDomicilio }}</div>
            <div style="display:flex;">
              <div style="width:50%;">
                <div>TELÉFONO:</div>
                <div style="background-color:#D5DBDB;">{{ detallesProductorTelefono }}</div>
              </div>
              <div style="width:50%;">
                <div>CORREO ELECTRÓNICO:</div>
                <div style="background-color:#D5DBDB;">{{ detallesProductorCorreo }}</div>
              </div>
            </div>
            <div>REGISTRO FEDERAL DE CONTRIBUYENTES:</div>
            <div style="background-color:#D5DBDB;">{{ rfcProductor }}</div>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="titulos">
            DETALLES DEL IMPORTADOR
          </div>
          <div style="font-size:10px;display:inline-flex;">
            <div class="mr-2" v-if="infoDespues.VALORESCHECKBOX.IMPORTADORDESCONOCIDO">
              <input type="checkbox" checked />Desconocidos
            </div>
            <div class="mr-2" v-if="!infoDespues.VALORESCHECKBOX.IMPORTADORDESCONOCIDO">
              <input type="checkbox" />Desconocidos
            </div>
            <!-- separador -->
            <div v-if="infoDespues.VALORESCHECKBOX.VARIOSIMPORTADORES">
              <input type="checkbox" checked />Varios importadores
            </div>
            <div v-if="!infoDespues.VALORESCHECKBOX.VARIOSIMPORTADORES">
              <input type="checkbox" />Varios importadores
            </div>
          </div>
          <div class="textos">
            <div>NOMBRE:</div>
            <div style="background-color:#D5DBDB;">{{ detallesImportadorNombre }}</div>
            <div>DOMICILIO:</div>
            <div style="background-color:#D5DBDB;">
              {{ detallesImportadorDomicilio }}
            </div>
            <div style="display:flex;">
              <div style="width:50%;">
                <div>TELÉFONO:</div>
                <div style="background-color:#D5DBDB;">
                  {{ detallesImportadorTelefono }}
                </div>
              </div>
              <div style="width:50%;">
                <div>CORREO ELECTRÓNICO:</div>
                <div style="background-color:#D5DBDB;">{{ detallesImportadorCorreoE }}</div>
              </div>
            </div>
            <div>REGISTRO FEDERAL DE CONTRIBUYENTES:</div>
            <div style="background-color:#D5DBDB;">{{ rfcImportador }}</div>
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-2">
        <v-col cols="12">
          <v-simple-table dense style="background-color:#d5dbdb ;">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center" style="font-size:10px;">CANTIDAD</th>
                  <th class="text-center" style="font-size:10px;">DESCRIPCIÓN DEL PRODUCTO</th>

                  <th class="text-center" style="font-size:10px;">CLASIFICACIÓN ARANCELARIA</th>
                  <th class="text-center" style="font-size:10px;">CRITERIO DE ORIGEN</th>
                  <th class="text-center" style="font-size:10px;">PAÍS DE ORIGEN</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in infoTMEC.fraccionesIterables" :key="index">
                  <td class="text-center" style="font-size:10px;">{{ item.cantidad }}</td>
                  <td class="text-center" style="font-size:10px;">
                    {{ item.des_en.toUpperCase() }}
                  </td>
                  <td class="text-center" style="font-size:10px;">{{ item.num_clasificacion }}</td>
                  <td class="text-center" style="font-size:10px;">C</td>
                  <td class="text-center" style="font-size:10px;">MEXICO</td>
                </tr>
                <tr
                  v-for="(item, index) in 7 - infoTMEC.fraccionesIterables.length"
                  :key="index + 'c'"
                >
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" class="mt-2">
          <div class="textos" style="text-align:left;">
            PERIODO GLOBAL <br />
            El periodo cubierto por la certificacion ( si aplica ) es hasta 12 meses de
            <span style="background-color:#d5dbdb ;padding:5px;">{{
              infoTMEC.fechaEnvioRango
            }}</span
            ><br />
            Firmado por el certificador
          </div>
        </v-col>
        <v-col cols="12">
          <div class="textos" style="text-align:left;max-width:80%;">
            Certifico que los productos descritos en este documento tienen procedencia y la
            informacion contenida en este documento es fiel y exacta. Asumo la responzabilidad para
            comprobar dichas representaciones y estoy deacuerdo en mantener y presentar a solicitud
            , o poner disposicion durante una visita de verificacion , la documentacion necesaria
            para soportar esta certificacion. <br />
            Esta certificacion consta en 1 paginas.
          </div>
        </v-col>
        <v-col cols="12">
          <v-row no-gutters>
            <v-col cols="2">
              <div class="textos">
                Firma del certificador:
              </div>
            </v-col>
            <v-col cols="7">
              <div class="textos">
                ___________________________________________________________
              </div>
            </v-col>
            <v-col cols="3">
              <div class="textos">Fecha {{ infoTMEC.fechaEnvio }}</div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
moment.locale("es");
export default {
  data() {
    return {
      row: "",
      elementos: [
        { cantidad: 1, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 2, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 3, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 4, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" },
        { cantidad: 5, descripcion: "das", descaran: "das", critorig: "das", paisorig: "das" }
      ],
      headers: [
        {
          text: "CANTIDAD",
          align: "center",
          sortable: false,
          value: "cantidad"
        },
        {
          text: "DESCRIPCIÓN DEL PRODUCTO",
          align: "center",
          sortable: false,
          value: "des_en"
        },
        {
          text: "CLASIFICACIÓN ARANCELARIA",
          align: "center",
          sortable: false,
          value: "num_clasificacion"
        },
        {
          text: "CRITERIO DE ORIGEN",
          align: "center",
          sortable: false,
          value: "'C'"
        },
        {
          text: "PAÍS DE ORIGEN",
          align: "center",
          sortable: false,
          value: "'MEXICO'"
        }
      ]
    };
  },
  computed: {
    ...mapState("documentosInternacional", {
      //infoDocumentoCommercialInvoice
      infoTMEC: state => state.infoDocumentoTMEC,
      infoDespues: state => state.infoDespues
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData
    }),
    direccionSucursalFormateada() {
      return (
        this.sucursalInfo.DIRECCION +
        " " +
        this.sucursalInfo.COLONIA +
        " " +
        this.sucursalInfo.CODIGO_POSTAL +
        " " +
        this.sucursalInfo.MUNICIPIO +
        " " +
        this.sucursalInfo.ESTADO
      ).toUpperCase();
    },
    rfcCertificador() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "PRODUCTOR") {
        return this.infoDespues.TAXIDREMITENTE || "-";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoDespues.TAXIDDESTINATARIO || "-";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "EXPORTADOR") {
        return this.infoDespues.TAXIDREMITENTE || "-";
      } else {
        return "-";
      }
    },
    rfcExportador() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoDespues.TAXIDREMITENTE || "-";
      } else {
        return "-";
      }
    },
    rfcProductor() {
      if (
        this.infoDespues.TIPOUSUARIOTMEC != "PRODUCTOR" &&
        !this.infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES &&
        !this.infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS
      ) {
        return this.infoDespues.DATOSPRODUCTOR.rfc || " - ";
      } else {
        return "-";
      }
    },
    rfcImportador() {
      if (this.infoDespues.TIPOUSUARIOTMEC != "IMPORTADOR") {
        return this.infoDespues.TAXIDDESTINATARIO || "-";
      } else {
        return "-";
      }
    },
    detallesCertificadorNombre() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "PRODUCTOR") {
        return this.infoDespues.TITULARDOCUMENTO || this.infoTMEC.Certificador.nombre || " - ";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoTMEC.Importador.nombre || "-";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "EXPORTADOR") {
        return this.infoDespues.TITULARDOCUMENTO || this.infoTMEC.Certificador.nombre || " - ";
      } else {
        return "-";
      }
    },
    detallesCertificadorDomicilio() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "PRODUCTOR") {
        return (
          this.infoDespues.DIRECCION ||
          this.infoTMEC.Certificador.direccion ||
          this.direccionSucursalFormateada ||
          " - "
        );
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoTMEC.Importador.direccion || "-";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "EXPORTADOR") {
        return (
          this.infoDespues.DIRECCION ||
          this.infoTMEC.Certificador.direccion ||
          this.direccionSucursalFormateada ||
          " - "
        );
      } else {
        return "-";
      }
    },
    detallesCertificadorTelefono() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "PRODUCTOR") {
        return this.infoTMEC.Certificador.telefono || " - ";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoTMEC.Importador.telefono || "-";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "EXPORTADOR") {
        return this.infoTMEC.Certificador.telefono || " - ";
      } else {
        return "-";
      }
    },
    detallesCertificadorCorreoElectronico() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "PRODUCTOR") {
        return "rufasa08@yahoo.com.mx";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return "rufasa08@yahoo.com.mx";
      } else if (this.infoDespues.TIPOUSUARIOTMEC == "EXPORTADOR") {
        return "rufasa08@yahoo.com.mx";
      } else {
        return "-";
      }
    },
    detallesExportadorNombre() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoDespues.TITULARDOCUMENTO || this.infoTMEC.Certificador.nombre || " - ";
      } else {
        return "-";
      }
    },
    detallesExportadorDomicilio() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoDespues.DIRECCION || this.infoTMEC.Certificador.direccion || " - ";
      } else {
        return "-";
      }
    },
    detallesExportadorTelefono() {
      if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
        return this.infoTMEC.Certificador.telefono || " - ";
      } else {
        return "-";
      }
    },
    detallesProductorNombre() {
      if (
        this.infoDespues.TIPOUSUARIOTMEC != "PRODUCTOR" &&
        !this.infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES &&
        !this.infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS
      ) {
        return this.infoDespues.DATOSPRODUCTOR.nombre || " - ";
      } else {
        return "-";
      }
    },
    detallesProductorDomicilio() {
      if (
        this.infoDespues.TIPOUSUARIOTMEC != "PRODUCTOR" &&
        !this.infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES &&
        !this.infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS
      ) {
        return this.infoDespues.DATOSPRODUCTOR.domicilio || " - ";
      } else {
        return "-";
      }
    },
    detallesProductorTelefono() {
      if (
        this.infoDespues.TIPOUSUARIOTMEC != "PRODUCTOR" &&
        !this.infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES &&
        !this.infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS
      ) {
        return this.infoDespues.DATOSPRODUCTOR.telefono || " - ";
      } else {
        return "-";
      }
    },
    detallesProductorCorreo() {
      if (
        this.infoDespues.TIPOUSUARIOTMEC != "PRODUCTOR" &&
        !this.infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES &&
        !this.infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS
      ) {
        return this.infoDespues.DATOSPRODUCTOR.correo || " - ";
      } else {
        return "-";
      }
    },
    detallesProductorRFC() {
      if (
        this.infoDespues.TIPOUSUARIOTMEC != "PRODUCTOR" &&
        !this.infoDespues.VALORESCHECKBOX.VARIOSPRODUCTORES &&
        !this.infoDespues.VALORESCHECKBOX.DISPONIBLEAUTORIDADESIMPORTADORAS
      ) {
        return this.infoDespues.DATOSPRODUCTOR.rfc || " - ";
      } else {
        return "-";
      }
    },
    //TODO IMPORTADOR
    detallesImportadorNombre() {
      if (this.infoDespues.TIPOUSUARIOTMEC != "IMPORTADOR") {
        return this.infoTMEC.Importador.nombre || "-";
      } else {
        return "-";
      }
    },
    detallesImportadorDomicilio() {
      if (this.infoDespues.TIPOUSUARIOTMEC != "IMPORTADOR") {
        return this.infoTMEC.Importador.direccion || "-";
      } else {
        return "-";
      }
    },
    detallesImportadorTelefono() {
      if (this.infoDespues.TIPOUSUARIOTMEC != "IMPORTADOR") {
        return this.infoTMEC.Importador.telefono || "-";
      } else {
        return "-";
      }
    },
    detallesImportadorCorreoE() {
      if (this.infoDespues.TIPOUSUARIOTMEC != "IMPORTADOR") {
        return "rufasa08@yahoo.com.mx";
      } else {
        return "-";
      }
    }
    // if (this.infoDespues.TIPOUSUARIOTMEC == "PRODUCTOR") {
    //     return "rufasa08@yahoo.com.mx";
    //   } else if (this.infoDespues.TIPOUSUARIOTMEC == "IMPORTADOR") {
    //     return "rufasa08@yahoo.com.mx";
    //   } else if (this.infoDespues.TIPOUSUARIOTMEC == "EXPORTADOR") {
    //     return "rufasa08@yahoo.com.mx";
    //   } else {
    //     return "-";
    //   }
  }
};
</script>
<style lang="css" scoped>
.marco {
  max-height: 970px;
  min-height: 970px;
  /* border: 3px solid red ; */
}
.titulos {
  font-weight: bold;
  font-size: 14px;
}
.smltrs {
  font-size: 8px;
}
.textos {
  font-weight: bold;
  font-size: 12px;
}

.textos .v-radio .v-label {
  font-size: 8px;
}
</style>
